import dayjs from "dayjs";

const tz = process.env.VUE_APP_TIMEZONE ?? "Europe/Madrid";

function createTimezoneDate({ value }: { value: string }): dayjs.Dayjs {
	return dayjs(value).tz(tz);
}

function formatTimezoneDate({ value, format }: { value: string; format: string }): string {
	const date = createTimezoneDate({ value });
	return date.format(format);
}

function formatDate({ value, format }: { value: string; format: string }): string {
	const date = dayjs.utc(value);
	return date.format(format);
}

function getDateMidnight({ date }: { date: string }): string | undefined {
	if (!date) {
		return;
	}

	const cleanDate = date.split("T")[0];
	const dateWithTimezone = dayjs.tz(`${cleanDate}T00:00:00`, tz);
	return dateWithTimezone.toISOString();
}

function mapTargetDate({ targetDate }: { targetDate?: string }): string | undefined {
	if (!targetDate) return;

	return getDateMidnight({ date: targetDate });
}

function mapPromotionBindingDate({ bindingDate }: { bindingDate: string }): string | undefined {
	return getDateMidnight({ date: bindingDate });
}

export const DateUtil = {
	getDateMidnight,
	createTimezoneDate,
	formatTimezoneDate,
	formatDate,
	mapTargetDate,
	mapPromotionBindingDate
};
